export default __webpack_public_path__ + "static/image9-92957f895ed5d255076502fc4bee4071.jpg";